import type { CargoDayTotal } from '../../services/api';

// Por día: planificados y ya cargados. Un día con 0 planificados pero algo
// cargado (la planning se puso a 0 después de rellenar, o se cargó de más)
// también se enseña en el calendario, en ámbar y como "cargados/planificados"
// (2026-09-10). Sin dependencias del navegador para poder probarse a secas.
export interface DayTotal { planned: number; loaded: number; }

export function totalsFromRows(rows: CargoDayTotal[]): Record<number, DayTotal> {
  const map: Record<number, DayTotal> = {};
  for (const r of rows) map[r.day] = { planned: Number(r.totalContainers || 0), loaded: Number(r.loadedContainers || 0) };
  return map;
}
